import { timeFormat } from "./removeLeadingZeros";
import { ToChronoFormat } from "./textTransform";
import { format, parse, parseISO, isValid } from 'date-fns'
import { fr } from 'date-fns/locale';


export function cleanText(str) {
    if (str) {
        return str
        .toLowerCase()
        .replace(/[-_\s]/g, "") // Remove '-', '_' and spaces
        .normalize("NFD") // Decompose accented characters
        .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
        .replace(/[sx]$/, "") // Remove 's' or 'x' at the end of the string
    } else {
        return null
    }
}

export function sortByCustomOrder(array, customOrder) {
    return array.sort((a, b) => {
        const indexA = customOrder.indexOf(a.id_topic);
        const indexB = customOrder.indexOf(b.id_topic);
        
        // Si les deux éléments ne sont pas dans customOrder, garder leur ordre relatif
        if (indexA === -1 && indexB === -1) {
            return 0;
        }
        
        // Si seulement un élément n'est pas dans customOrder, le mettre à la fin
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        
        // Si les deux éléments sont dans customOrder, les trier selon l'ordre spécifié
        return indexA - indexB;
    });
}